/** @jsxImportSource @emotion/react */
import React from 'react'
import { css, Global } from '@emotion/react';
import { margin, marginMobile } from "../styling/theme";
import PillButton from "../components/common/PillButton";
import { desktop, mobile } from "../styling/media";
import { useMediaQuery } from "react-responsive";


interface Props {

}

const LandingPage: React.FC<Props> = () => {
  const isDesktop = useMediaQuery(desktop);
  const buttonCSS = css`
    width: 30%;
    flex-basis: 30%;
    flex-grow: 0;
    flex-shrink: 0;
  `
  return (
    <>
      <Global styles={css`
        html {
          background: white;
          color: black;

          a {
            color: black;

            &:visited {
              color: black;
            }
          }
        }
      `} />
      <div
        css={css`
          position: absolute;
          left: 0;
          top: 0;
          display: flex;
          flex-direction: column;
          width: calc(100vw - ${margin.main * 2}px);
          height: calc(100vh - ${margin.main * 2}px);
          padding: ${margin.main}px;

          @media ${mobile.query} {
            padding: ${marginMobile.main}px;
            width: calc(100vw - ${marginMobile.main * 2}px);
            height: calc(100vh - ${marginMobile.main * 2}px);
            display: block;
          }

          & > div {
            flex-basis: 33%;
            flex-shrink: 0;
          }
        `}
      >
        <div
          css={css`
            display: flex;
            @media ${mobile.query} {
              flex-direction: column;
            }
          `}
        >
          <div
          >
            Visualize and share your thoughts and ideas about the climate crisis with the COAL + ICE Climate Posterator
          </div>
          <div
            css={css`
              padding-left: ${margin.main}px;
              @media ${mobile.query} {
                padding-left: 0;
                padding-top: ${marginMobile.main}px
              }
            `}

          >
            The COAL + ICE Climate Posterator is a project of <a
              href="https://asiasociety.org/" target="_blank">Asia Society</a> for the <a
                href="https://coalandice.org/" target="_blank">COAL + ICE</a> exhibition at the Asia Society Museum in New York. .
          </div>
        </div>

        {isDesktop ? <>
          <div
            css={css`
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
            `}
          >
            <PillButton addCSS={buttonCSS} to="/editor">Create Poster</PillButton>
            <PillButton addCSS={buttonCSS} to="/gallery">View Gallery</PillButton>
            <PillButton addCSS={buttonCSS} to="/info">Learn More</PillButton>

          </div>
          <div
            css={css`
              display: flex;
              flex-direction: row;
              align-items: flex-end;
              justify-content: space-between;

              & > div {
                flex-basis: 30%;
              }
            `}
          >
            <div>
              Our tool is easy to use and doesn’t require any design experience.
            </div>
            <div>
              Get inspired, or download poster that others designed.
            </div>
            <div>
              Who’s behind the project? What’s the framework?
            </div>
          </div>
        </> : <>
          <div css={css`
            display: flex;
            width: 100%;
            margin: ${marginMobile.main}px 0;
          `}>
            <PillButton
              to="/editor"
              addCSS={css`
                flex-basis: 100%;
              `}
            >
              Create Poster
            </PillButton>
          </div>
          <div>
            Our tool is easy to use and doesn’t require any design experience.
          </div>
          <div css={css`
            display: flex;
            width: 100%;
            margin: ${marginMobile.main}px 0;
          `}>
            <PillButton
              to="/gallery"
              addCSS={css`
                flex-basis: 100%;
              `}
            >
              View Gallery
            </PillButton>
          </div>
          <div>
            Get inspired, or download poster that others designed.
          </div>
          <div css={css`
            display: flex;
            width: 100%;
            margin: ${marginMobile.main}px 0;
          `}>
            <PillButton
              to="/info"
              addCSS={css`
                flex-basis: 100%;
              `}
            >
              Learn More
            </PillButton>
          </div>
          <div>
            Who’s behind the project? What’s the framework?.
          </div>
        </>}
      </div>
    </>
  )
}

export default LandingPage;
